export default __webpack_public_path__ + "static/img02-c01a11f782e05b8f9dfacaff99792f92.png";